import { DateTime } from 'luxon';

function renderDateTime(s)
{
  return DateTime.fromISO(s, { zone: "UTC" }).setZone('system').toLocaleString(DateTime.DATETIME_MED);
}

export { renderDateTime };
